import '@d3fc/d3fc-element';
import { line } from 'utils/components/TimeSeriesChart/line';
import { SignalChartTimeSeriesItem } from 'widgets/signalTiles/signalTile/components/chart/signalTileData';

export const middleLine = line<SignalChartTimeSeriesItem>(
    (d) => d.middle,
    'middle-line'
);
